import type { Modify } from "core/js/typescript-utility-types";
import Instant from "core/js/class/instant";
import LocalDate from "core/js/class/local-date";
import { ajaxGet, ajaxPost } from "core/js/spring-ajax";

const SCIM_TOKENS_ENDPOINT = "/authentication/rest/api/scim-tokens";

export type ScimTokenStatus = "ACTIVE" | "DEACTIVATED";

type JsonScimTokenResponse = {
  id: number,
  last4DigitToken: string,
  issueDate: string,
  status: ScimTokenStatus,
  lastUsedAt?: string,
  deactivatedAt?: string,
  createdByUserId: number,
};

export type JsonScimToken = Modify<JsonScimTokenResponse, {
  issueDate: LocalDate,
  lastUsedAt?: Instant,
  deactivatedAt?: Instant,
}>;

export type JsonScimGeneratedToken = {
  id: number,
  rawToken: string,
  issueDate: string,
};

export async function getScimTokens(): Promise<Array<JsonScimToken>> {
  type JsonScimTokenList = { tokens: Array<JsonScimTokenResponse> };
  const tokens = (await ajaxGet<JsonScimTokenList>({ url: SCIM_TOKENS_ENDPOINT })).tokens;
  return tokens.map(token => ({
    ...token,
    issueDate: new LocalDate(token.issueDate),
    lastUsedAt: token.lastUsedAt ? new Instant(token.lastUsedAt) : undefined,
    deactivatedAt: token.deactivatedAt ? new Instant(token.deactivatedAt) : undefined,
  })).toSorted((a, b) => {
    return a.status.localeCompare(b.status) || b.id - a.id;
  });
}

export async function createScimToken(): Promise<JsonScimGeneratedToken> {
  return await ajaxPost<void, JsonScimGeneratedToken>({
    url: SCIM_TOKENS_ENDPOINT,
  });
}
